import { ArticleFilter } from '../components/article-filter';

export default ArticleGrid = () => {
	const sections = document.querySelectorAll('.section-article-grid');
	if (!sections.length) return;

	const cardTemplate = document.querySelector('#blog-card-template');
	const createArticleCard = (data) => {
		const { filter, article, page, order, blog } = data;

		const cardElement = document.createElement('div');
		cardElement.classList.add('col');
		cardElement.setAttribute('data-page', page);
		cardElement.setAttribute('data-order', order);

		const cardInner = cardTemplate.content.cloneNode(true);
		if (!cardInner) return;

		cardElement.appendChild(cardInner);

		let isNew = false;
		if (window.mx.articleFilters.newTagType == 'tag') {
			for (const tag of article.tags) {
				if (tag.toUpperCase() == 'NEW') {
					isNew = true;
					break;
				}
			}
		} else if (window.mx.articleFilters.newTagType == 'date') {
			const publishedAt = new Date(article.publishedAt)?.getTime()
			if (publishedAt) {
				const now = new Date().getTime();
				const diff = now - publishedAt;
				const days = Math.floor(diff / (1000 * 60 * 60 * 24));
				if (days < window.mx.articleFilters.newTagDays) {
					isNew = true;
				}
			}
		}
		if (isNew) {
			cardElement.querySelectorAll('[data-card-tags]').forEach(ele => {
				ele.innerHTML = `
				<div class="tag">
					<svg xmlns="http://www.w3.org/2000/svg" width="7" height="26" viewBox="0 0 7 26" fill="none">
						<path d="M1 0H7V26H1L0 20.5L1 0Z" fill="#B42025"/>
					</svg>
					<span>NEW</span>
					<svg xmlns="http://www.w3.org/2000/svg" width="7" height="27" viewBox="0 0 7 27" fill="none">
						<path d="M7 0L0 1V27H6L7 9V0Z" fill="#B42025"/>
					</svg>
				</div>
			`
			})
		}


		cardElement.querySelectorAll('[data-card-url]').forEach((ele) => {
			ele.href = article.onlineStoreUrl;
		});
		cardElement.querySelectorAll('[data-card-title]').forEach((ele) => {
			ele.innerHTML = article.title;
		});
		if (blog === 'Recipes') {
			cardElement.querySelectorAll('[data-button-text]').forEach((ele) => {
				ele.innerHTML = 'Get the Recipe';
			})
		}

		// if (article.prepTime?.value) {
		// 	if (!article.prepTime.value.includes('min') && 
		// 		!article.prepTime.value.includes('hour') && 
		// 		!article.prepTime.value.includes('hr')) {
		// 		article.prepTime.value += ' mins';
		// 	}
		// 	cardElement.querySelectorAll('[data-card-prep]').forEach((ele) => {
		// 		ele.innerHTML = 'Prep time: ' + article.prepTime.value;
		// 	});
		// }
		// if (article.cookTime?.value) {
		// 	if (!article.cookTime.value.includes('min') && 
		// 		!article.cookTime.value.includes('hour') && 
		// 		!article.cookTime.value.includes('hr')) {
		// 		article.cookTime.value += ' mins';
		// 	}
		// 	cardElement.querySelectorAll('[data-card-cook]').forEach((ele) => {
		// 		ele.innerHTML = 'Cook time: ' + article.cookTime.value;
		// 	});
		// }
		cardElement.querySelectorAll('[data-card-image]').forEach((ele) => {
			ele.src = article.image?.src || filter.fallbackImage
			ele.alt = article.title;
		});

		let category = blog;
		for (const tag of article.tags) {
			if (tag.includes('Course_')) {
				category = tag.replace('Course_', '');
				break;
			} else if (tag.includes('Category_')) {
				category = tag.replace('Category_', '');
				break;
			}
		}
		cardElement.querySelectorAll('[data-card-category]').forEach((ele) => {
			ele.innerHTML = category;
		})

		return cardElement;
	}

	for (const section of sections) {

		const filter = new ArticleFilter(section, {
            storeDomain: 'http://kodiakcakes.com',
            publicAccessToken: 'f0cd9a0824c3af9ac19fd37fc6cc0c40',
            apiVersion: '2024-10',
			graphQL: `
				title
				tags
				onlineStoreUrl
				publishedAt
				image {
					src
				}`,
			createCard: createArticleCard,
		});

		const toggleSidebarButton = section.querySelector('.btn-toggle-filters');
		if (toggleSidebarButton) {
			const text = toggleSidebarButton.querySelector('.toggle-text')
			const sidebar = section.querySelector('.col-filters');
			toggleSidebarButton.addEventListener('click', () => {
				sidebar.classList.toggle('sidebar-open');
				if (sidebar.classList.contains('sidebar-open')) {
					text.innerHTML = 'Hide Filters';
				} else {
					text.innerHTML = 'Show Filters';
				}
			});
		}
	}
};
